module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Iris Murdoch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v(" Iris Murdoch (1919–1999) is the author of twenty-six novels, including "), _c('I', [_vm._v("Under the Net, The Black Prince, ")]), _vm._v("and"), _c('I', [_vm._v(" The Sea, The Sea")]), _vm._v(", as well as several plays and a volume of poetry. Murdoch taught philosophy at Oxford before leaving to write fulltime, winning such literary awards as the Booker Prize and the PEN Gold Pen for Distinguished Service to Literature. ")], 1), _c('P', [_vm._v("   ")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/T2p0Gs/tc-custom/9781453201091.jpg?1733083257134",
      "alt": "This image is the cover for the book Unofficial Rose"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unofficial Rose\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A Shakespearean comedy of misaligned lovers” set in the modern English countryside by a Man Booker Prize winner ("), _c('i', [_vm._v("Publishers Weekly")]), _vm._v("). ")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Hugh Peronett’s life is tinged with regret: the regret of never following his passions and losing the one woman he loved. Twenty-five years ago, he ended an affair with Emma Sands, a detective novelist who had stolen his heart, to be with his wife, Fanny. Now, Fanny is gone, and both Hugh and his grown son, Randall, find themselves at a crossroads of passion and righteousness."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" As Hugh, Emma, Randall, Randall’s wife, Randall’s mistress, and several others are caught in a dance of romance and rejection in bucolic rural England, they will discover the true meanings of love, companionship, and desire."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" From the acclaimed author of "), _c('i', [_vm._v("The Sea, The Sea")]), _vm._v(", "), _c('i', [_vm._v("An Unofficial Rose")]), _vm._v(" is a novel of wit, sorrow and an unparalleled psychological insight.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0